var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"error_message body2"},[_c('font-awesome-icon',{staticClass:"error_message__icon",attrs:{"icon":['fas', 'exclamation-triangle']}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }